import { render, staticRenderFns } from "./TextSettings.vue?vue&type=template&id=944c840e&"
import script from "./TextSettings.vue?vue&type=script&lang=js&"
export * from "./TextSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports